import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { State } from '@app/core/ngrx/reducers';
import { select, Store } from '@ngrx/store';
import { applicationChainSelectors } from '@app/core/ngrx/selectors';
import { faStethoscope } from '@fortawesome/pro-regular-svg-icons';
import {
    faBookMedical,
    faBriefcaseMedical,
    faLaptopMedical,
    faMapMarkerAlt,
    faNotesMedical,
    faTooth,
    faUserNurse,
    faCheck,
    faChevronRight,
    faChevronLeft,
} from '@fortawesome/pro-solid-svg-icons';
import { closestTo, compareAsc, isAfter, isBefore } from 'date-fns';
import { ApplicationChainActions } from '@app/core/ngrx/actions';
import { MutationService } from '@app/core/graphql/mutation/mutation.service';
import { ApplicationService } from '@app/core/services/application/application.service';
import { QueryService } from '@app/core/graphql/query/query.service';
import { IonSlides } from '@ionic/angular';

@Component({
    selector: 'app-application-chain-enrolled',
    templateUrl: './application-chain-enrolled.component.html',
    styleUrls: ['./application-chain-enrolled.component.scss'],
})
export class ApplicationChainEnrolledComponent implements OnChanges {
    @Input() chainedApplications: any;
    @Input() profile: any;
    @Input() applicationChainState: string;

    @ViewChild('mySlider') slides: IonSlides;

    faNotesMedical = faNotesMedical;
    faMapMarkerAlt = faMapMarkerAlt;
    faStethoscope = faStethoscope;
    faBookMedical = faBookMedical;
    faBriefcaseMedical = faBriefcaseMedical;
    faLaptopMedical = faLaptopMedical;
    faTooth = faTooth;
    faUserNurse = faUserNurse;
    faCheck = faCheck;
    faChevronRight = faChevronRight;
    faChevronLeft = faChevronLeft;

    iconOfType: any;

    timelineLabelFirst = '';
    timelineLabelSecond = '';
    timelineLabelThird = '';

    applicationDates: any;
    selectedApplication: any = { startdate: Date, enddate: Date };
    sortedApplicationChain: any;
    status: any;

    applicationChain$ = this.store.pipe(
        select(applicationChainSelectors.getApplicationChain)
    );
    applicationChain: any;

    showChecklist = true;
    showDocuments = false;
    showProgram = false;

    reviewType: any;
    applicationTimeline = {};
    promptForMidRotationReview = false;
    showMidRotationReview = false;
    showPostRotationReview = false;

    selectedProgram: any;
    options = {
        arrows: true,
        animation: {
            animationClass: 'transition',
            animationTime: 200,
        },
        swipe: {
            swipeable: true,
            swipeVelocity: 1,
        },
        drag: {
            draggable: true,
            dragMany: true,
        },
        infinite: false,
        breakpoints: [
            {
                width: 768,
                number: 1,
            },
            {
                width: 991,
                number: 3,
            },
            {
                width: 9999,
                number: 3,
            },
        ],
    };

    slideOpts = {
        slidesPerView: 3,
        initialSlide: 0,
        speed: 400,
        allowSlideNext: true,
        allowSlidePrev: true,
        breakpoints: {
            1390: {
                slidesPerView: 2,
                spaceBetween: 40,
            },
            992: {
                slidesPerView: 1,
                spaceBetween: 40,
            },
        },
    };

    fillLine = {};

    today = new Date();

    showPreDepartureRegistration: any = {};

    constructor(
        private store: Store<State>,
        private applicationService: ApplicationService,
        private queryService: QueryService
    ) {}

    ngOnChanges() {
        this.applicationChain$.subscribe(a => {
            this.applicationChain = [...a];
        });
        this.sortedApplicationChain = [...this.applicationChain].sort(
            (a, b) =>
                new Date(a.startdate).getTime() -
                new Date(b.startdate).getTime()
        );

        this.sortedApplicationChain.forEach(a => {
            this.applicationTimeline[
                this.sortedApplicationChain.indexOf(a)
            ] = isAfter(this.today, new Date(a.enddate));
        });

        const totalApplicationLength = Object.keys(this.applicationTimeline)
            .length;

        const pastApplications = Object.values(this.applicationTimeline).filter(
            a => a === true
        ).length;

        const width = (pastApplications / totalApplicationLength) * 125;

        this.fillLine = { width: `${width}%` };

        const dateArray = this.sortedApplicationChain.map(a => {
            return a.startdate;
        });

        const currentApplication = this.sortedApplicationChain.filter(a => {
            const startdate = closestTo(this.today, dateArray).getTime();
            if (Date.parse(a.startdate) === startdate) {
                return a;
            }
        });

        this.applicationSelected(currentApplication[0], 0);

        // if (isMobileDevice()) {
        // } else {
        //     this.applicationSelected(
        //         currentApplication[0],
        //         this.applicationChain.indexOf(currentApplication[0])
        //     );
        // }

        const preDepartureList = this.applicationChain.map(a => {
            return a.predepartureorientation;
        });

        // // show the mid rotation review section.
        // user will always submit a mid rotation review from this page.
    }

    segmentChanged(ev: any) {
        this.showChecklist = ev.detail.value === 'checklist' ? true : false;
        this.showDocuments = ev.detail.value === 'documents' ? true : false;
        this.showProgram = ev.detail.value === 'program' ? true : false;
    }

    submitMidRotationReview() {
        this.showMidRotationReview = true;
    }

    applicationSelected(application: any, index: number, mobile?: boolean) {
        this.applicationDates = {
            startdate: application.startdate,
            enddate: application.enddate,
        };

        this.promptForMidRotationReview = false;
        this.showPostRotationReview = false;

        const cut = this.applicationChain.splice(index, 1);

        this.applicationChain.splice(index, 0, cut[0]);
        console.log(this.applicationChain);

        this.applicationChain.sort(
            (a, b) =>
                new Date(a.startdate).getTime() -
                new Date(b.startdate).getTime()
        );

        // if (mobile) {
        // } else {
        //     this.applicationChain.splice(1, 0, cut[0]);
        // }

        this.store.dispatch(
            ApplicationChainActions.setApplicationsInChain({
                applications: this.applicationChain,
            })
        );

        this.selectedApplication = application;

        this.getProgramDetails(this.selectedApplication.programid);

        this.applicationService
            .promptForMidRotationReview(application.id)
            .subscribe((response: any) => {
                this.promptForMidRotationReview =
                    response.promptMidRotationReview;
            });

        if (
            isAfter(this.today, this.selectedApplication.enddate) === true &&
            application.states === 'Enrolled'
        ) {
            this.showPostRotationReview = true;
            this.status = {
                user: application.User,
                application: application,
                program: application.Program,
                applicationState: application.states,
            };
        } else {
            this.status = {
                user: application.User,
                application: application,
                program: application.Program,
                applicationState: application.states,
            };
        }

        if (
            isBetween(
                this.today,
                new Date(this.applicationDates.startdate),
                new Date(this.applicationDates.enddate)
            )
        ) {
            this.timelineLabelSecond = 'In Progress';
            this.timelineLabelFirst = 'In Progress';
            this.timelineLabelThird = '';
        } else if (isBefore(this.today, this.applicationDates.startdate)) {
            this.timelineLabelFirst = 'Up Next';
            this.timelineLabelSecond = '';
            this.timelineLabelThird = '';
        } else if (isAfter(this.today, this.applicationDates.enddate)) {
            this.timelineLabelThird = 'Complete';
            this.timelineLabelFirst = 'Complete';
            this.timelineLabelSecond = '';
        }
    }

    rightClick(ev) {
        this.slides.slideNext();

        const index = this.applicationChain.indexOf(this.selectedApplication);
        if (index < this.applicationChain.length - 1) {
            this.applicationSelected(
                this.applicationChain[index + 1],
                index + 1,
                true
            );
        }
    }

    leftClick(ev) {
        this.slides.slidePrev();

        const index = this.applicationChain.indexOf(this.selectedApplication);
        if (index > 0) {
            this.applicationSelected(
                this.applicationChain[index - 1],
                index - 1,
                true
            );
        }
    }

    getProgramDetails(programid: string) {
        if (programid) {
            this.queryService
                .findProgram(programid)
                .subscribe((response: any) => {
                    if (response.data.program) {
                        this.selectedProgram = { ...response.data.program };
                    }
                });
        }
    }
}

const isBetween = (date: Date, min: Date, max: Date) =>
    date.getTime() >= min.getTime() && date.getTime() <= max.getTime();

const isMobileDevice = () => {
    return (
        typeof window.orientation !== 'undefined' ||
        navigator.userAgent.indexOf('IEMobile') !== -1
    );
};
